/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import '../../assets/style/Modal.css';
import ModalHeader from '../../components/ModalHeader';
import { TASK_DETAILS_HEADER } from '../attendance/ViewAttendeesPageHelper';
import KTable from '../../components/KTable';
import {
  ATTENDEES_STATUS,
  CLICK_ACTIONS,
  DATE_FORMAT,
} from '../../utils/Constant';
import CenterSpinner from '../../components/CenterSpinner';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import {
  checkNullValue,
  formattedDateWithFormat,
  getNoteDate,
  isAPIFailed,
  isAPISuccess,
} from '../../utils/Util';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  approveOrRejectAttendance,
  attendanceSelector,
  fetchAttendanceDetails,
} from '../../features/attendanceSlice';
import { toast } from 'react-toastify';
import BasicDetails from '../../components/BasicDetails';
import { Image } from 'react-bootstrap';
import ImagePreviewModal from './ImagePreviewModal';
import { VIEW_APPROVALHISTORY_HEADER } from '../attendance/ViewAttendeesPageHelper';
interface IAttendanceModalProps {
  isOpen: boolean;
  selectedUser?: any;
  toggleModal: (action: string) => void;
}

const AttendanceModal: React.FunctionComponent<IAttendanceModalProps> = ({
  isOpen,
  selectedUser,
  toggleModal,
}: IAttendanceModalProps) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [comment, setComment] = useState<string>();
  const dispatch = useAppDispatch();
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState<boolean>(false);
  const [showDistanceLog, setShowDistanceLog] = useState<boolean>(false);
  const [isApprovalEnabled, setIsApprovalEnabled] = useState<boolean>(false);

  const attendanceDetails =
    useAppSelector(attendanceSelector).attendanceDetails;

  const taskDistanceTableData = (
    attendanceDetails?.dailySummary?.perTaskDistanceDetails ?? []
  ).map((task: any) => ({
    taskId: task.taskId ?? '-',

    taskStartedLocation: task.taskStartedAt ?? 'N/A - No check-in',

    taskCompletedLocation: task.taskCompletedAt ?? 'NA',

    duration: task.duration ?? 'NA',

    distance: Number(task.distance ?? 0).toFixed(2),
  }));

  const approvedRejectedStatus =
    useAppSelector(attendanceSelector).approvedRejectedStatus;
  const handleApproveRejectAttandence = (type: string) => {
    if (!comment && type === 'reject') {
      toast.error('Comment is required');
      return;
    }
    const data: any = {
      attendanceRegisterId: selectedUser.attendanceRegisterId, //selectedUser?.attendanceRegisterId,
      comments: comment ?? '',
    };

    data.status = type === 'reject' ? 1 : 0;
    setShowLoader(true);
    dispatch(approveOrRejectAttendance(data));

    // .unwrap()
    // .then((fulfilled: any) => {
    //   setShowLoader(false);
    //   if (isAPIFailed(fulfilled)) {
    //     toast.error(fulfilled.responseInformation.responseMessage);
    //   } else if (isAPISuccess(fulfilled)) {
    //     toast.success(fulfilled.responseInformation.responseMessage);
    //     toggleModal(CLICK_ACTIONS.NO_ACTION);
    //   }
    // })
    // .catch(() => {
    //   setShowLoader(false);
    // });
  };

  const getAttandenceDetails = () => {
    if (selectedUser) {
      setShowLoader(true);
      dispatch(
        fetchAttendanceDetails({
          markAttendanceId: selectedUser?.attendanceRegisterId,
        })
      );
    }
  };
  useEffect(() => {
    if (approvedRejectedStatus?.responseMessage) {
      setShowLoader(false);
    }
    if (isAPIFailed({ responseInformation: approvedRejectedStatus })) {
      toast.error(approvedRejectedStatus?.responseMessage);
    } else if (isAPISuccess({ responseInformation: approvedRejectedStatus })) {
      toast.success(approvedRejectedStatus?.responseMessage);
      toggleModal(CLICK_ACTIONS.NO_ACTION);
    }
  }, [approvedRejectedStatus]);
  useEffect(() => {
    setShowLoader(false);
  }, [attendanceDetails]);
  useEffect(() => {
    getAttandenceDetails();
  }, [selectedUser]);

  const togglePreviewModal = () => {
    setIsPreviewModalOpen(!isPreviewModalOpen);
  };
  useEffect(() => {
    if (attendanceDetails) {
      setIsApprovalEnabled(attendanceDetails?.isEnabled);
    }
  }, [attendanceDetails]);

  const getAttendanceDetails = () => (
    <div className="mx-4">
      <div className="toolBar-name">Attendance Details</div>

      <Row>
        <Col xs={6} md={6}>
          <Label className="mb-0 model-label-name">Check-in Date & Time</Label>
          <br />
          <Label className="mb-0 model-label-name-black">
            {' '}
            {attendanceDetails?.checkInTime
              ? formattedDateWithFormat(
                  attendanceDetails?.checkInTime,
                  DATE_FORMAT.DD_MM_YYYY_hh_mm_A
                )
              : '-'}
          </Label>
        </Col>
        <Col xs={6} md={6}>
          <Label className="mb-0 model-label-name">Check-out Date & Time</Label>
          <br />
          <Label className="mb-0 model-label-name-black">
            {' '}
            {attendanceDetails?.checkOutTime
              ? formattedDateWithFormat(
                  attendanceDetails?.checkOutTime,
                  DATE_FORMAT.DD_MM_YYYY_hh_mm_A
                )
              : '-'}
          </Label>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={6} md={6}>
          <Label className="mb-0 model-label-name">Check-in Location</Label>
          <br />
          <Label
            className={`mb-0 ${
              !attendanceDetails?.isInTheRadius
                ? 'model-label-value-red'
                : 'model-label-value'
            }`}
          >
            {' '}
            {checkNullValue(attendanceDetails?.checkInLocationName)}
          </Label>
        </Col>
        <Col xs={6} md={6}>
          <Label className="mb-0 model-label-name">Assigned Location</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {' '}
            {checkNullValue(attendanceDetails?.assignedLocationName)}
          </Label>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={6} md={4}>
          <Label className="mb-0 model-label-name">
            Attendance Check-in Selfie Picture
          </Label>
          <br />
          <Label className="mb-0 model-label-value">
            {' '}
            <Image
              aria-label="selfie"
              src={String(attendanceDetails?.checkinPicture)}
              width={50}
              onClick={togglePreviewModal}
            />
          </Label>
        </Col>
        {selectedUser?.approvalStatus !== ATTENDEES_STATUS?.MARKED && (
          <>
            <Col xs={6} md={4}>
              <Label className="mb-0 model-label-name">
                {attendanceDetails?.approvalStatusName.replace('_', ' ') ??
                  'Approved'}{' '}
                On
              </Label>
              <br />
              <Label className="mb-0 model-label-value">
                {' '}
                {attendanceDetails?.approvedOn
                  ? formattedDateWithFormat(
                      attendanceDetails?.checkOutTime,
                      DATE_FORMAT.DD_MM_YYYY
                    )
                  : '-'}
              </Label>
            </Col>
            <Col xs={6} md={4}>
              <Label className="mb-0 model-label-name">
                {attendanceDetails?.approvalStatusName.replace('_', ' ') ??
                  'Approved'}{' '}
                By
              </Label>
              <br />
              <Label className="mb-0 model-label-value">
                {' '}
                {checkNullValue(attendanceDetails?.approverName)}
              </Label>
            </Col>
          </>
        )}
      </Row>
      {selectedUser?.approvalStatus === ATTENDEES_STATUS?.MARKED &&
      attendanceDetails?.approvalHistory?.length ? (
        <Row className="mt-4">
          <Label className="mb-0 model-label-name">
            Attendance Approval Details
          </Label>
          <br />
          <Col xs={12} md={12}>
            <KTable
              data={attendanceDetails?.approvalHistory}
              tableParentClass=""
              columnHeader={VIEW_APPROVALHISTORY_HEADER}
              onAction={() => {}}
              isLoading={false}
              showNoDataFoundMsg={false}
            />
          </Col>
        </Row>
      ) : null}
      <Row className="mt-4">
        <Col xs={12} md={6} xl={3}>
          <div className="visitorsCard countCard">
            <p className="cardHeading">
              Total Distance Travelled{' '}
              {attendanceDetails?.dailySummary?.totalDistanceTravelled > 0 ? (
                <span
                  role="button"
                  title="Please click to view/hide details"
                  className="text-decoration-underline cardContent"
                  style={{ color: '#000', cursor: 'pointer' }}
                  onClick={() => setShowDistanceLog(!showDistanceLog)}
                >
                  {Number(
                    attendanceDetails?.dailySummary?.totalDistanceTravelled
                  ).toFixed(2)}{' '}
                  km
                </span>
              ) : (
                <span style={{ color: '#000' }} className="cardContent">
                  {Number(
                    attendanceDetails?.dailySummary?.totalDistanceTravelled ?? 0
                  ).toFixed(2)}{' '}
                  km
                </span>
              )}
            </p>
          </div>
        </Col>

        <Col xs={12} md={6} xl={3}>
          <div className="leadsCard countCard">
            <p className="cardHeading">
              Tasks Created{' '}
              <span className="cardContent">
                {attendanceDetails?.dailySummary?.selfTaskCreatedToday}
              </span>
            </p>
          </div>
        </Col>

        <Col xs={12} md={6} xl={3}>
          <div className="registeredCard countCard">
            <p className="cardHeading">
              Tasks Assigned{' '}
              <span className="cardContent">
                {attendanceDetails?.dailySummary?.assignedTaskCreatedToday}
              </span>
            </p>
          </div>
        </Col>
        <Col xs={12} md={6} xl={3}>
          <div className="registeredCard countCard">
            <p className="cardHeading">
              Total Tasks Completed{' '}
              <span className="cardContent">
                {attendanceDetails?.dailySummary?.tasksCompleted}
              </span>
            </p>
          </div>
        </Col>

        <Col xs={12} md={6} xl={3}>
          <div className="complaintsCard countCard">
            <p className="cardHeading">
              Total Leads Created{' '}
              <span className="cardContent">
                {attendanceDetails?.dailySummary?.leadsCreated}
              </span>
            </p>
          </div>
        </Col>
      </Row>
      {showDistanceLog && (
        <Row className="mt-3">
          <Col xs={12}>
            <div className="bg-white rounded border p-3">
              <KTable
                data={taskDistanceTableData}
                columnHeader={TASK_DETAILS_HEADER}
                isLoading={showLoader}
                tableParentClass="task-details-scroll"
                onAction={() => {}}
              />
            </div>
          </Col>
        </Row>
      )}

      <div>
        <div className="bg-comment p-4 mt-5 rounded">
          {selectedUser?.approvalStatus === ATTENDEES_STATUS?.MARKED && (
            <div className="mb-3">
              <FormGroup>
                <Label for="comment" className="model-comment-title">
                  Comments &#40;<span className="text-danger ">* </span>
                  {''} Mandatory for Rejection&#41;
                </Label>
                <Input
                  id="comment"
                  name="comment"
                  type="textarea"
                  maxLength={250}
                  value={comment}
                  placeholder="Please Comment"
                  className="rounded border model-comment-area"
                  onChange={(event) => setComment(event.target.value)}
                />
              </FormGroup>
            </div>
          )}

          <div className="bg-white rounded border px-4 pt-3 pb-3">
            <Label for="comment" className="model-comment-title">
              Log Details
            </Label>
            <div className="modal-log-div">
              <ul className="li-item model-log-value">
                {attendanceDetails?.notes?.length &&
                  attendanceDetails?.notes.map((noteItem: any) => (
                    <li
                      className="mt-1"
                      key={noteItem.notesid ?? noteItem.notesId}
                    >
                      {getNoteDate(noteItem)}
                      {noteItem.notesDescription}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {selectedUser?.approvalStatus === ATTENDEES_STATUS?.MARKED &&
      attendanceDetails?.canApprove ? (
        <div className="d-flex justify-content-center mt-5 mb-2">
          <Button
            variant="primary"
            className="m-1 cl-btn-primary"
            disabled={!isApprovalEnabled}
            onClick={() => {
              handleApproveRejectAttandence('approve');
            }}
          >
            Approve
          </Button>
          <Button
            variant="outline-primary"
            className="m-1 cl-btn-outline-primary"
            disabled={!isApprovalEnabled}
            onClick={() => {
              handleApproveRejectAttandence('reject');
            }}
          >
            Reject
          </Button>
        </div>
      ) : (
        <div className="d-flex justify-content-center mt-5 mb-2">
          <Button
            variant="primary"
            className="m-1 cl-btn-primary"
            onClick={() => {
              toggleModal(CLICK_ACTIONS.NO_ACTION);
            }}
          >
            Close
          </Button>
        </div>
      )}
    </div>
  );
  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleModal(CLICK_ACTIONS.NO_ACTION);
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="d-flex justify-content-center">
        <div className="bg-white p-2 modal-90 rounded border">
          <ModalHeader
            photoUrl={attendanceDetails?.photo}
            toggle={() => {
              toggleModal(CLICK_ACTIONS.NO_ACTION);
            }}
          />
          <BasicDetails user={attendanceDetails} employeeKeyShow={true} />
          {getAttendanceDetails()}
          <CenterSpinner showLoader={showLoader} />
          <ImagePreviewModal
            isItUrl={true}
            isOpen={isPreviewModalOpen}
            onApproveRejectAction={() => {}}
            photoURL={attendanceDetails?.checkinPicture}
            toggle={togglePreviewModal}
          />
        </div>
      </div>
    </ModalComponent>
  );
};

export default AttendanceModal;
